export enum InvitationCodeStatus {
  PI_UNSET = 'PI_UNSET', // Do not use, needed because of proto3 limitations
  PI_ACTIVATED = 'PI_ACTIVATED',
  PI_DEACTIVATED = 'PI_DEACTIVATED',
}
